"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var VMFunctionBytecodeCompiler_1;
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMFunctionBytecodeCompiler = void 0;
const inversify_1 = require("inversify");
const estraverse = __importStar(require("@javascript-obfuscator/estraverse"));
const IVMCompilerUtils_1 = require("../../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../../interfaces/vm-transformers/IVMScopeManager");
const IVMVariableCollector_1 = require("../../../interfaces/vm-transformers/analyzers/IVMVariableCollector");
const IVMClosureAnalyzer_1 = require("../../../interfaces/vm-transformers/analyzers/IVMClosureAnalyzer");
const VMOpCode_1 = require("../../../enums/vm-transformers/VMOpCode");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../node/NodeGuards");
const VMConstants_1 = require("../../VMConstants");
const IScopeIdentifiersTraverser_1 = require("../../../interfaces/node/IScopeIdentifiersTraverser");
const NodeFactory_1 = require("../../../node/NodeFactory");
let VMFunctionBytecodeCompiler = VMFunctionBytecodeCompiler_1 = class VMFunctionBytecodeCompiler {
    constructor(vmCompilerUtils, variableCollector, scopeIdentifiersTraverser, closureAnalyzer, scopeManager) {
        this.vmCompilerUtils = vmCompilerUtils;
        this.variableCollector = variableCollector;
        this.scopeIdentifiersTraverser = scopeIdentifiersTraverser;
        this.closureAnalyzer = closureAnalyzer;
        this.scopeManager = scopeManager;
    }
    compileFunctionExpression(node, context) {
        var _a, _b;
        const isArrow = NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(node);
        const childContext = this.vmCompilerUtils.createContext(context, isArrow);
        childContext.declaredVariables = this.collectAllDeclaredVariables(node);
        const functionName = this.extractFunctionName(node, childContext);
        const paramInfo = this.registerParameters(node.params, childContext);
        this.closureAnalyzer.analyzeEnvironmentVariables(node, childContext);
        this.copyParametersToEnvironment(childContext);
        this.emitEarlyTDZForDefaultParams(paramInfo.defaultParams, childContext, context);
        this.emitDefaultParameterCode(paramInfo.defaultParams, childContext);
        this.emitDestructuredParameterCode(paramInfo.destructuredParams, childContext);
        if (paramInfo.restParamName !== null) {
            this.emitRestParameterCode(paramInfo.restParamName, paramInfo.restParamPattern, paramInfo.regularParamCount, childContext);
        }
        const envVarsBeforeBody = new Set(childContext.envVars);
        const functionBodyStartIndex = childContext.instructions.length;
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(node.body)) {
            this.compileBlockStatementBody(node.body, childContext);
        }
        else {
            this.compileExpressionBody(node.body, childContext, context);
        }
        this.handleThisStorage(isArrow, functionBodyStartIndex, childContext);
        this.copyParametersToEnvironmentLate(functionBodyStartIndex, childContext, envVarsBeforeBody);
        this.finalizeFunctionCompilation(childContext, context, paramInfo.regularParamCount, (_a = node.async) !== null && _a !== void 0 ? _a : false, (_b = node.generator) !== null && _b !== void 0 ? _b : false, functionName);
    }
    compileCompoundOperator(operator, context) {
        const opcode = VMFunctionBytecodeCompiler_1.compoundOpMap[operator];
        if (opcode !== undefined) {
            context.instructions.push({ op: opcode });
        }
        else {
            const builder = this.vmCompilerUtils.createInstructionBuilder(context);
            builder.pushUndefined();
        }
    }
    extractFunctionName(node, childContext) {
        var _a, _b;
        if (NodeGuards_1.NodeGuards.isFunctionExpressionNode(node) && ((_a = node.id) === null || _a === void 0 ? void 0 : _a.name)) {
            const name = node.id.name;
            childContext.envVars.add(name);
            childContext.functionName = name;
            return name;
        }
        if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node) && ((_b = node.id) === null || _b === void 0 ? void 0 : _b.name)) {
            const name = node.id.name;
            childContext.functionName = name;
            return name;
        }
        return null;
    }
    emitEarlyTDZForDefaultParams(defaultParams, childContext, parentContext) {
        if (defaultParams.length === 0) {
            return;
        }
        const builder = this.vmCompilerUtils.createInstructionBuilder(childContext);
        const referencedVars = new Set();
        for (const { defaultExpr } of defaultParams) {
            this.closureAnalyzer.scanNodeForIdentifiers(defaultExpr, referencedVars);
        }
        for (const varName of referencedVars) {
            if (parentContext.localVariablesInTDZ.has(varName)) {
                builder.declareTDZ(varName);
            }
        }
    }
    compileBlockStatementBody(body, context) {
        var _a;
        this.hoistVarDeclarationsToLocals(body, context);
        this.hoistFunctionDeclarations(body, context);
        this.initializeHoistedVarEnvVariables(body, context);
        this.initializeLateDefinedEnvVariables(body, context);
        const lexicalDeclarations = this.variableCollector.scanForLexicalDeclarations(body.body);
        if (lexicalDeclarations.size > 0) {
            this.scopeManager.enterLocalsTDZ(context, [...lexicalDeclarations]);
        }
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        for (const varName of lexicalDeclarations) {
            builder.declareTDZ(varName);
        }
        context.isFunctionBody = true;
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.statement(body);
        context.isFunctionBody = false;
    }
    compileExpressionBody(body, childContext, parentContext) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(childContext);
        const referencedVars = new Set();
        this.closureAnalyzer.scanNodeForIdentifiers(body, referencedVars);
        for (const varName of referencedVars) {
            if (parentContext.localVariablesInTDZ.has(varName)) {
                builder.declareTDZ(varName);
            }
        }
        (_a = childContext.dispatch) === null || _a === void 0 ? void 0 : _a.expression(body);
        builder.return();
    }
    finalizeFunctionCompilation(childContext, parentContext, regularParamCount, isAsync, isGenerator, functionName) {
        const childLocalIdToParentLocalId = this.mergeNestedFunctions(childContext, parentContext);
        const nestedBytecode = this.createNestedBytecode(childContext, regularParamCount, childLocalIdToParentLocalId, isAsync, isGenerator, functionName);
        const localFuncId = parentContext.nestedFunctions.size;
        parentContext.nestedFunctions.set(localFuncId, nestedBytecode);
        const builder = this.vmCompilerUtils.createInstructionBuilder(parentContext);
        const funcIdIndex = parentContext.constantPool.forceAdd(localFuncId);
        parentContext.functionRefIndices.add(funcIdIndex);
        builder.loadConstByIndex(funcIdIndex);
        this.propagateCapturedVariables(childContext, parentContext);
        builder.newFunc();
    }
    registerParameters(params, context) {
        let regularParamCount = 0;
        const defaultParams = [];
        const destructuredParams = [];
        let restParamName = null;
        let restParamPattern = null;
        if (!params) {
            return { regularParamCount, defaultParams, destructuredParams, restParamName, restParamPattern };
        }
        params.forEach((param, index) => {
            if (NodeGuards_1.NodeGuards.isIdentifierNode(param)) {
                this.registerSimpleParameter(param, index, context);
                regularParamCount++;
            }
            else if (NodeGuards_1.NodeGuards.isAssignmentPatternNode(param)) {
                regularParamCount++;
                this.registerDefaultParameter(param, index, context, defaultParams, destructuredParams);
            }
            else if (NodeGuards_1.NodeGuards.isArrayPatternNode(param) || NodeGuards_1.NodeGuards.isObjectPatternNode(param)) {
                this.registerDestructuredParameter(param, index, destructuredParams);
                regularParamCount++;
            }
            else if (NodeGuards_1.NodeGuards.isRestElementNode(param)) {
                const result = this.registerRestParameter(param, context);
                restParamName = result.restParamName;
                restParamPattern = result.restParamPattern;
            }
        });
        return { regularParamCount, defaultParams, destructuredParams, restParamName, restParamPattern };
    }
    registerSimpleParameter(param, index, context) {
        context.parameters.set(param.name, index);
    }
    registerDefaultParameter(param, index, context, defaultParams, destructuredParams) {
        if (NodeGuards_1.NodeGuards.isIdentifierNode(param.left)) {
            context.parameters.set(param.left.name, index);
            defaultParams.push({
                paramIndex: index,
                defaultExpr: param.right
            });
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(param.left) || NodeGuards_1.NodeGuards.isObjectPatternNode(param.left)) {
            destructuredParams.push({
                paramIndex: index,
                pattern: param.left
            });
            defaultParams.push({
                paramIndex: index,
                defaultExpr: param.right
            });
        }
    }
    registerDestructuredParameter(param, index, destructuredParams) {
        destructuredParams.push({
            paramIndex: index,
            pattern: param
        });
    }
    registerRestParameter(param, context) {
        let restParamName;
        let restParamPattern = null;
        if (NodeGuards_1.NodeGuards.isIdentifierNode(param.argument)) {
            restParamName = param.argument.name;
            const localIndex = context.localVariables.size;
            context.localVariables.set(restParamName, localIndex);
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(param.argument) || NodeGuards_1.NodeGuards.isObjectPatternNode(param.argument)) {
            restParamPattern = param.argument;
            restParamName = '__rest_temp__';
            const localIndex = context.localVariables.size;
            context.localVariables.set(restParamName, localIndex);
        }
        else {
            restParamName = '__rest_temp__';
            const localIndex = context.localVariables.size;
            context.localVariables.set(restParamName, localIndex);
        }
        return { restParamName, restParamPattern };
    }
    emitDefaultParameterCode(defaultParams, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        for (const { paramIndex, defaultExpr } of defaultParams) {
            builder.loadArg(paramIndex);
            const skipDefault = builder.emitUndefinedCheck();
            builder.pop();
            context.parametersInTDZ.clear();
            for (const [paramName, pIndex] of context.parameters) {
                if (pIndex >= paramIndex) {
                    context.parametersInTDZ.add(paramName);
                }
            }
            for (const [pName, pIndex] of context.parameters) {
                if (pIndex > paramIndex && context.envVars.has(pName)) {
                    builder.declareTDZ(pName);
                }
            }
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(defaultExpr);
            builder.storeArg(paramIndex);
            let paramName = null;
            for (const [name, index] of context.parameters) {
                if (index === paramIndex) {
                    paramName = name;
                    break;
                }
            }
            if (paramName && context.envVars.has(paramName)) {
                builder.loadArg(paramIndex);
                builder.storeToEnvByName(paramName);
                builder.pop();
            }
            const jumpToEnd = builder.jump();
            skipDefault.patchToHere();
            builder.pop();
            jumpToEnd.patchToHere();
        }
        context.parametersInTDZ.clear();
    }
    emitDestructuredParameterCode(destructuredParams, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const previousCompilingParameters = context._compilingFunctionParameters;
        context._compilingFunctionParameters = true;
        for (const { paramIndex, pattern } of destructuredParams) {
            builder.loadArg(paramIndex);
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.destructuring(pattern, false);
        }
        if (previousCompilingParameters !== undefined) {
            context._compilingFunctionParameters = previousCompilingParameters;
        }
        else {
            delete context._compilingFunctionParameters;
        }
    }
    emitRestParameterCode(restParamName, restParamPattern, regularParamCount, context) {
        this.vmCompilerUtils.emitRestParameterHandling(restParamName, restParamPattern, regularParamCount, context);
    }
    copyParametersToEnvironment(context, defaultParamIndices = new Set()) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        let needsChildEnv = false;
        for (const [paramName] of context.parameters) {
            if (context.envVars.has(paramName)) {
                if (!context.parentContext) {
                    needsChildEnv = true;
                    break;
                }
                else if (this.vmCompilerUtils.isDeclaredInParentScope(paramName, context.parentContext)) {
                    needsChildEnv = true;
                    break;
                }
            }
        }
        if (!needsChildEnv && context.parentContext) {
            for (const varName of context.envVars) {
                if (context.parameters.has(varName)) {
                    continue;
                }
                if (varName === context.functionName) {
                    continue;
                }
                if (this.vmCompilerUtils.isDeclaredInParentScope(varName, context.parentContext)) {
                    needsChildEnv = true;
                    break;
                }
            }
        }
        const shouldInheritParentEnv = context.parentContext && context.parentContext.envDepth > 0;
        if (shouldInheritParentEnv || needsChildEnv) {
            if (shouldInheritParentEnv) {
                builder.getEnv();
                builder.createEnv();
                context.envDepth++;
            }
            else if (needsChildEnv) {
                builder.getEnv();
                builder.createEnv();
                context.envDepth++;
            }
            context.needsEnvRestoreAtEnd = true;
        }
        for (const [paramName, paramIndex] of context.parameters) {
            if (context.envVars.has(paramName)) {
                if (defaultParamIndices.has(paramIndex)) {
                    continue;
                }
                builder.loadArg(paramIndex);
                if (needsChildEnv) {
                    builder.storeToCurrentEnvByName(paramName);
                }
                else {
                    builder.storeToEnvByName(paramName);
                }
                builder.pop();
            }
        }
    }
    initializeHoistedVarEnvVariables(blockStatement, context) {
        const varDeclarations = new Set();
        this.vmCompilerUtils.traverseStatements(blockStatement.body, (stmt) => {
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(stmt) && stmt.kind === 'var') {
                for (const decl of stmt.declarations) {
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(decl.id)) {
                        const varName = decl.id.name;
                        if (context.envVars.has(varName) && !this.isShadowedByFunctionOrParam(varName, context)) {
                            varDeclarations.add(varName);
                        }
                    }
                    else if (NodeGuards_1.NodeGuards.isArrayPatternNode(decl.id) || NodeGuards_1.NodeGuards.isObjectPatternNode(decl.id)) {
                        const destructuredVars = new Set();
                        this.variableCollector.collectFromPattern(decl.id, destructuredVars);
                        for (const varName of destructuredVars) {
                            if (context.envVars.has(varName) && !this.isShadowedByFunctionOrParam(varName, context)) {
                                varDeclarations.add(varName);
                            }
                        }
                    }
                }
            }
        });
        for (const varName of varDeclarations) {
            this.emitEnvVarInit(varName, context);
        }
    }
    hoistVarDeclarationsToLocals(blockStatement, context) {
        for (const statement of blockStatement.body) {
            this.vmCompilerUtils.traverseBlocksSkipScopes(statement, (node) => {
                if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node) && node.kind === 'var') {
                    for (const declarator of node.declarations) {
                        const identifiers = this.vmCompilerUtils.extractIdentifiersFromPattern(declarator.id);
                        for (const varName of identifiers) {
                            if (context.localVariables.has(varName) || context.parameters.has(varName)) {
                                continue;
                            }
                            const localIndex = context.localVariables.size;
                            context.localVariables.set(varName, localIndex);
                        }
                    }
                }
            });
        }
    }
    initializeLateDefinedEnvVariables(blockStatement, context) {
        const declaredVars = new Set([...context.parameters.keys(), ...context.localVariables.keys()]);
        const allDeclaredVarsInFunction = new Set(declaredVars);
        this.collectAllDeclaredVarsInBlock(blockStatement, allDeclaredVarsInFunction);
        const lateDefinedVars = this.findLateDefinedVars(blockStatement.body, declaredVars, allDeclaredVarsInFunction, context);
        this.emitLateDefinedVarInitialization(lateDefinedVars, context);
    }
    collectAllDeclaredVarsInBlock(blockStatement, result) {
        estraverse.traverse(blockStatement, {
            enter: (node) => {
                if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node)) {
                    for (const decl of node.declarations) {
                        const identifiers = this.vmCompilerUtils.extractIdentifiersFromPattern(decl.id);
                        for (const varName of identifiers) {
                            result.add(varName);
                        }
                    }
                }
                else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node)) {
                    result.add(node.id.name);
                }
                if (NodeGuards_1.NodeGuards.isFunctionOrClassNode(node)) {
                    return estraverse.VisitorOption.Skip;
                }
            }
        });
    }
    collectIdentifierReferencesFromNode(targetNode, refs) {
        estraverse.traverse(targetNode, {
            enter: (node, parent) => {
                if (NodeGuards_1.NodeGuards.isIdentifierNode(node)) {
                    if (parent &&
                        NodeGuards_1.NodeGuards.isMemberExpressionNode(parent) &&
                        parent.property === node &&
                        !parent.computed) {
                        return;
                    }
                    if (parent && NodeGuards_1.NodeGuards.isPropertyNode(parent) && parent.key === node && !parent.computed) {
                        return;
                    }
                    refs.add(node.name);
                }
                if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node) || NodeGuards_1.NodeGuards.isClassNode(node)) {
                    return estraverse.VisitorOption.Skip;
                }
            }
        });
    }
    findClosuresInStatement(stmt) {
        const closures = [];
        estraverse.traverse(stmt, {
            enter: (node) => {
                if (NodeGuards_1.NodeGuards.isFunctionExpressionNode(node) || NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(node)) {
                    closures.push(node);
                }
                if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node) || NodeGuards_1.NodeGuards.isClassNode(node)) {
                    return estraverse.VisitorOption.Skip;
                }
            }
        });
        return closures;
    }
    markStatementDeclarations(stmt, declaredVars) {
        estraverse.traverse(stmt, {
            enter: (node) => {
                if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node)) {
                    for (const decl of node.declarations) {
                        const identifiers = this.vmCompilerUtils.extractIdentifiersFromPattern(decl.id);
                        for (const varName of identifiers) {
                            declaredVars.add(varName);
                        }
                    }
                }
                else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node)) {
                    declaredVars.add(node.id.name);
                }
                if (NodeGuards_1.NodeGuards.isFunctionOrClassNode(node)) {
                    return estraverse.VisitorOption.Skip;
                }
            }
        });
    }
    findLateDefinedVars(statements, declaredVars, allDeclaredVarsInFunction, context) {
        const lateDefinedVars = new Set();
        for (const stmt of statements) {
            this.markStatementDeclarations(stmt, declaredVars);
            const closures = this.findClosuresInStatement(stmt);
            for (const closure of closures) {
                const referencedVars = new Set();
                this.collectIdentifierReferencesFromNode(closure, referencedVars);
                for (const varName of referencedVars) {
                    if (this.isLateDefinedEnvVar(varName, declaredVars, allDeclaredVarsInFunction, context)) {
                        lateDefinedVars.add(varName);
                    }
                }
            }
        }
        return lateDefinedVars;
    }
    isLateDefinedEnvVar(varName, declaredVars, allDeclaredVarsInFunction, context) {
        if (declaredVars.has(varName)) {
            return false;
        }
        if (!context.envVars.has(varName)) {
            return false;
        }
        if (!allDeclaredVarsInFunction.has(varName)) {
            return false;
        }
        if (this.isShadowedByFunctionOrParam(varName, context)) {
            return false;
        }
        return true;
    }
    emitLateDefinedVarInitialization(lateDefinedVars, context) {
        if (lateDefinedVars.size === 0) {
            return;
        }
        const actualLateDefinedEnvVars = new Set();
        for (const varName of lateDefinedVars) {
            if (context.envVars.has(varName)) {
                actualLateDefinedEnvVars.add(varName);
            }
        }
        if (actualLateDefinedEnvVars.size === 0) {
            return;
        }
        if (!context.lateDefinedEnvVars) {
            context.lateDefinedEnvVars = new Set();
        }
        for (const varName of actualLateDefinedEnvVars) {
            context.lateDefinedEnvVars.add(varName);
            this.emitEnvVarInit(varName, context);
        }
    }
    handleThisStorage(isArrow, functionBodyStartIndex, context) {
        var _a, _b;
        if (isArrow) {
            return false;
        }
        let needsThisStorage = false;
        let needsArgumentsStorage = false;
        for (const [, nestedBytecode] of context.nestedFunctions) {
            if ((_a = nestedBytecode.capturedVars) === null || _a === void 0 ? void 0 : _a.includes(VMConstants_1.VM_SPECIAL_VARS.capturedThis)) {
                needsThisStorage = true;
            }
            if ((_b = nestedBytecode.capturedVars) === null || _b === void 0 ? void 0 : _b.includes(VMConstants_1.VM_SPECIAL_VARS.capturedArguments)) {
                needsArgumentsStorage = true;
            }
            if (needsThisStorage && needsArgumentsStorage) {
                break;
            }
        }
        const storageInstructions = [];
        if (needsThisStorage) {
            const thisNameIndex = context.constantPool.add(VMConstants_1.VM_SPECIAL_VARS.capturedThis);
            storageInstructions.push({ op: VMOpCode_1.VMOpCode.THIS }, { op: VMOpCode_1.VMOpCode.STORE_TO_ENV, arg: thisNameIndex }, { op: VMOpCode_1.VMOpCode.POP });
        }
        if (needsArgumentsStorage) {
            const argumentsNameIndex = context.constantPool.add(VMConstants_1.VM_SPECIAL_VARS.capturedArguments);
            storageInstructions.push({ op: VMOpCode_1.VMOpCode.ARGUMENTS, arg: 0 }, { op: VMOpCode_1.VMOpCode.STORE_TO_ENV, arg: argumentsNameIndex }, { op: VMOpCode_1.VMOpCode.POP });
        }
        if (storageInstructions.length > 0) {
            context.instructions.splice(functionBodyStartIndex, 0, ...storageInstructions);
            this.vmCompilerUtils.adjustJumpTargetsAfterInsertion(functionBodyStartIndex, storageInstructions.length, context);
            return true;
        }
        return false;
    }
    copyParametersToEnvironmentLate(functionBodyStartIndex, context, envVarsBeforeBody) {
        const lateParamsToCopy = [];
        for (const [paramName, paramIndex] of context.parameters) {
            if (context.envVars.has(paramName) && !envVarsBeforeBody.has(paramName)) {
                lateParamsToCopy.push([paramName, paramIndex]);
            }
        }
        if (lateParamsToCopy.length === 0) {
            return;
        }
        const instructions = [];
        for (const [paramName, paramIndex] of lateParamsToCopy) {
            const nameIndex = context.constantPool.add(paramName);
            instructions.push({ op: VMOpCode_1.VMOpCode.LOAD_ARG, arg: paramIndex });
            if (context.needsEnvRestoreAtEnd) {
                instructions.push({ op: VMOpCode_1.VMOpCode.STORE_TO_CURRENT_ENV, arg: nameIndex });
            }
            else {
                instructions.push({ op: VMOpCode_1.VMOpCode.STORE_TO_ENV, arg: nameIndex });
            }
            instructions.push({ op: VMOpCode_1.VMOpCode.POP });
        }
        context.instructions.splice(functionBodyStartIndex, 0, ...instructions);
        this.vmCompilerUtils.adjustJumpTargetsAfterInsertion(functionBodyStartIndex, instructions.length, context);
    }
    mergeNestedFunctions(childContext, parentContext) {
        const childLocalIdToParentLocalId = new Map();
        for (const [childLocalId] of childContext.nestedFunctions) {
            const parentLocalId = parentContext.nestedFunctions.size + childLocalIdToParentLocalId.size;
            childLocalIdToParentLocalId.set(childLocalId, parentLocalId);
        }
        for (const [childLocalId, childNestedBytecode] of childContext.nestedFunctions) {
            const parentLocalId = childLocalIdToParentLocalId.get(childLocalId);
            const remappedConstants = childNestedBytecode.constants.map((constant, index) => {
                var _a;
                if (((_a = childNestedBytecode.functionRefIndices) === null || _a === void 0 ? void 0 : _a.has(index)) &&
                    typeof constant === 'number' &&
                    childLocalIdToParentLocalId.has(constant)) {
                    return childLocalIdToParentLocalId.get(constant);
                }
                return constant;
            });
            parentContext.nestedFunctions.set(parentLocalId, {
                ...childNestedBytecode,
                constants: remappedConstants
            });
        }
        return childLocalIdToParentLocalId;
    }
    createNestedBytecode(childContext, regularParamCount, childLocalIdToParentLocalId, isAsync, isGenerator, functionName) {
        let functionNameIndex;
        if (functionName) {
            functionNameIndex = childContext.constantPool.add(functionName);
        }
        const nestedBytecode = {
            id: childContext.nextBytecodeId++,
            constants: childContext.constantPool.getAll(),
            instructions: childContext.instructions,
            params: regularParamCount,
            locals: childContext.localVariables.size,
            capturedVars: Array.from(childContext.capturedVars),
            functionRefIndices: childContext.functionRefIndices,
            isArrow: childContext.isArrowFunction,
            isAsync: isAsync,
            isGenerator: isGenerator,
            functionNameIndex: functionNameIndex
        };
        const remappedConstants = nestedBytecode.constants.map((constant, index) => {
            var _a;
            if (((_a = nestedBytecode.functionRefIndices) === null || _a === void 0 ? void 0 : _a.has(index)) &&
                typeof constant === 'number' &&
                childLocalIdToParentLocalId.has(constant)) {
                return childLocalIdToParentLocalId.get(constant);
            }
            return constant;
        });
        nestedBytecode.constants = remappedConstants;
        return nestedBytecode;
    }
    propagateCapturedVariables(childContext, parentContext) {
        for (const varName of childContext.capturedVars) {
            const childDeclares = this.contextDeclaresVariable(varName, childContext, true);
            const parentDeclares = this.contextDeclaresVariable(varName, parentContext, false);
            if (childDeclares && (parentDeclares || !parentContext.declaredVariables)) {
                continue;
            }
            if (parentDeclares) {
                if (!parentContext.envVars.has(varName)) {
                    parentContext.envVars.add(varName);
                }
                continue;
            }
            if (!parentContext.capturedVars.has(varName)) {
                parentContext.capturedVars.add(varName);
                if (varName === VMConstants_1.VM_SPECIAL_VARS.capturedThis) {
                    parentContext.capturedThis = true;
                }
                if (varName === VMConstants_1.VM_SPECIAL_VARS.capturedArguments) {
                    parentContext.capturedArguments = true;
                }
            }
            const isParameter = parentContext.parameters.has(varName) && !parentContext.parametersInTDZ.has(varName);
            if (!isParameter && !parentContext.envVars.has(varName)) {
                parentContext.envVars.add(varName);
            }
        }
    }
    contextDeclaresVariable(varName, context, isChildContext) {
        var _a;
        if (context.localVariables.has(varName)) {
            return true;
        }
        if (context.parameters.has(varName) && !context.parametersInTDZ.has(varName)) {
            return true;
        }
        const baseName = varName.split('$$')[0];
        const hasMatchingBaseName = this.hasMatchingBaseNameVariable(baseName, context, isChildContext);
        if (hasMatchingBaseName) {
            return true;
        }
        if (!isChildContext && ((_a = context.declaredVariables) === null || _a === void 0 ? void 0 : _a.has(varName))) {
            return true;
        }
        return false;
    }
    hasMatchingBaseNameVariable(baseName, context, applyDepthFilter) {
        for (const key of context.localVariables.keys()) {
            const parts = key.split('$$');
            const keyBaseName = parts[0];
            if (keyBaseName !== baseName) {
                continue;
            }
            if (applyDepthFilter) {
                const depth = parts.length > 1 ? parseInt(parts[1], 10) : 0;
                if (depth > 1) {
                    continue;
                }
            }
            return true;
        }
        for (const key of context.parameters.keys()) {
            if (key.split('$$')[0] === baseName) {
                return true;
            }
        }
        return false;
    }
    hoistFunctionDeclarations(blockStatement, context) {
        var _a;
        for (const statement of blockStatement.body) {
            if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(statement) && statement.id) {
                const funcName = statement.id.name;
                (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.statement(statement);
                context.hoistedFunctionDeclarations.add(funcName);
            }
        }
    }
    collectAllDeclaredVariables(node) {
        const declared = new Set();
        const syntheticProgram = NodeFactory_1.NodeFactory.programNode([]);
        if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(node)) {
            syntheticProgram.body.push(node);
        }
        else {
            const expressionStatement = NodeFactory_1.NodeFactory.expressionStatementNode(node);
            syntheticProgram.body.push(expressionStatement);
        }
        this.scopeIdentifiersTraverser.traverseScopeIdentifiers(syntheticProgram, null, (data) => {
            declared.add(data.variable.name);
        });
        return declared;
    }
    isShadowedByFunctionOrParam(varName, context) {
        const isNFEShadowing = varName === context.functionName;
        const isParameterShadowing = context.parameters.has(varName) && !context.parametersInTDZ.has(varName);
        return isNFEShadowing || isParameterShadowing;
    }
    emitEnvVarInit(varName, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const nameIndex = context.constantPool.add(varName);
        builder.pushUndefined();
        builder.storeToCurrentEnv(nameIndex);
        builder.pop();
    }
};
exports.VMFunctionBytecodeCompiler = VMFunctionBytecodeCompiler;
VMFunctionBytecodeCompiler.compoundOpMap = {
    '+=': VMOpCode_1.VMOpCode.ADD,
    '-=': VMOpCode_1.VMOpCode.SUB,
    '*=': VMOpCode_1.VMOpCode.MUL,
    '/=': VMOpCode_1.VMOpCode.DIV,
    '%=': VMOpCode_1.VMOpCode.MOD,
    '**=': VMOpCode_1.VMOpCode.EXPONENT,
    '<<=': VMOpCode_1.VMOpCode.SHL,
    '>>=': VMOpCode_1.VMOpCode.SHR,
    '>>>=': VMOpCode_1.VMOpCode.USHR,
    '&=': VMOpCode_1.VMOpCode.BIT_AND,
    '|=': VMOpCode_1.VMOpCode.BIT_OR,
    '^=': VMOpCode_1.VMOpCode.BIT_XOR
};
exports.VMFunctionBytecodeCompiler = VMFunctionBytecodeCompiler = VMFunctionBytecodeCompiler_1 = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMVariableCollector)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IScopeIdentifiersTraverser)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMClosureAnalyzer)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object, typeof (_b = typeof IVMVariableCollector_1.IVMVariableCollector !== "undefined" && IVMVariableCollector_1.IVMVariableCollector) === "function" ? _b : Object, typeof (_c = typeof IScopeIdentifiersTraverser_1.IScopeIdentifiersTraverser !== "undefined" && IScopeIdentifiersTraverser_1.IScopeIdentifiersTraverser) === "function" ? _c : Object, typeof (_d = typeof IVMClosureAnalyzer_1.IVMClosureAnalyzer !== "undefined" && IVMClosureAnalyzer_1.IVMClosureAnalyzer) === "function" ? _d : Object, typeof (_e = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _e : Object])
], VMFunctionBytecodeCompiler);
